import React from 'react';
import { useParams } from 'react-router-dom';

export default function LegalPage() {
  const { type } = useParams();
  
  const content = {
    privacy: {
      title: 'Privacy Policy',
      desc: 'How Eldenwyck & Co. handles and protects your personal data.'
    },
    terms: {
      title: 'Terms of Use',
      desc: 'The governing terms for using our website and services.'
    },
    cookies: {
      title: 'Cookie Policy',
      desc: 'Information about how we use cookies to improve your experience.'
    }
  }[type] || { title: 'Legal Notice', desc: 'Standard legal disclosures.' };

  return (
    <div className="pt-40 pb-24 bg-slate-50 min-h-screen">
      <div className="max-w-3xl mx-auto px-6 lg:px-8 bg-white p-12 shadow-sm">
        <h1 className="text-3xl font-serif text-slate-900 mb-4">{content.title}</h1>
        <p className="text-slate-500 mb-8 pb-8 border-b border-slate-100">{content.desc}</p>
        
        <div className="prose prose-slate max-w-none text-slate-600">
          <p className="mb-6">Last Updated: October 2023</p>
          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">1. Information Collection</h2>
          <p className="mb-6">
            Eldenwyck & Co. collects information to provide better services to all our clients. We collect information in the following ways: Information you give us, Information we get from your use of our services.
          </p>
          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">2. Use of Information</h2>
          <p className="mb-6">
            We use the information we collect from all our services to provide, maintain, protect and improve them, to develop new ones, and to protect Eldenwyck & Co. and our users.
          </p>
          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">3. Data Security</h2>
          <p className="mb-6">
            We work hard to protect Eldenwyck & Co. and our users from unauthorized access to or unauthorized alteration, disclosure or destruction of information we hold.
          </p>
          <p className="mt-12 text-sm italic">
            For further inquiries regarding our legal standing, please contact legal@eldenwyck.com
          </p>
        </div>
      </div>
    </div>
  );
}